module.exports = __webpack_public_path__ + "static/img/image1.e50da3fe.png";